import SaunaRegistrationForm from '@/components/SaunaRegistration/SaunaRegistration'

const Register = () => {
  return (
    <>
      <div>Register your sauna here</div>
      <SaunaRegistrationForm />
    </>

  )
}

export default Register